<template>
  <span>
    <v-overlay :value="fileLoading">
      <v-progress-circular
        indeterminate
        size="64"
      />
    </v-overlay>
    <v-form>
      <v-card
        flat
        max-width="800"
      >
        <v-card-text>
          <v-form ref="detailsDocumentsRequiredForm">
            <v-text-field
              v-model="data.doc_required_file_name"
              label="Наименование файла"
              :rules="[rules.reguired]"
            />
            <v-text-field
              v-model="data.short_file_name"
              label="Короткое имя файла"
              :rules="[rules.reguired]"
            />
            <a
              v-if="data.doc_required_file_example"
              href="#"
              @click="download(data.doc_required_file_example)"
            >Образец</a>
            <v-file-input
              v-model="data.file"
              chips
              label="Образец документа"
            />
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="success"
            class="mr-4"
            @click="save"
          >
            Сохранить
          </v-btn>
          <v-btn
            class="mr-4"
            @click="close"
          >
            Отмена
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </span>
</template>

<script>
export default {
  name: 'DocumentsRequestsRequiredDetails',
  props: {
    data: {}
  },
  data () {
    return {
      rules: {
        reguired: v => !!v || 'Заполните это поле!'
      },
      fileLoading: false
    }
  },
  mounted () {
  },
  methods: {
    sendFile () {
      var formData = new FormData()
      if (this.data.file) {
        formData.append('files', this.data.file, this.data.file.name)
      } else {
        return
      }

      this.axios.patch(`/api/document_required_file/${this.data.doc_required_file_id}/`, formData).then(() => {
      }).catch(error => {
        console.log(error)
      })
    },
    close () {
      this.$emit('close')
    },
    save () {
      if (this.$refs.detailsDocumentsRequiredForm.validate()) {
        if (this.data.doc_required_file_id === null) {
          this.axios.post('/api/document_required_file/', this.data).then((response) => {
            this.data.doc_required_file_id = response.data.doc_required_file_id
            this.sendFile()
            this.close()
          }).catch((err) => {
            console.log(err)
            this.loading = false
          })
        } else {
          this.axios.patch(`/api/document_required_file/${this.data.doc_required_file_id}/`, this.data).then(() => {
            this.sendFile()
            this.close()
          }).catch((err) => {
            console.log(err)
            this.loading = false
          })
        }
      }
    },
    download (file) {
      this.fileLoading = true
      this.axios({
        url: `/api/download/${file.file_name}`,
        method: 'GET',
        responseType: 'blob'
      }).then((response) => {
        var blob = new Blob([response.data], { type: response.data.type })
        var link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        const contentDisposition = response.headers['content-disposition']
        let fileName = file.file_name
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.setAttribute('download', decodeURI(fileName))
        document.body.appendChild(link)
        link.click()
        link.remove()
        this.fileLoading = false
      }).catch((err) => {
        console.log(err)
        this.fileLoading = false
      })
    }
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/spa/documents-requests/DocumentsRequestsRequiredDetails.vue